import { r as registerInstance, h } from './index-c269755a.js';

const teliaNavigationButtonCss = ".telia-navigation-button{padding:0}button{background:none;border:0;display:flex;font-family:\"TeliaSans\", Helvetica, Arial, \"Lucida Grande\", sans-serif;justify-content:center;padding:0}button slot{align-items:center;display:flex;justify-content:space-between;width:100%}";

const TeliaNavigationButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    /** Native href attribute of anchor element  */
    /** Link size prop, to render telia-navigation-button in different sizes */
    this.size = 'sm';
    /** Link active status, boolean true or false, default is false */
    this.active = false;
    /** If this button has expanded an element, set this prop to true. */
    this.allyExpanded = false;
    /** Describe unclear button context for better accessibility support */
    this.allyLabel = null;
    /** Applies dropdown styling on the button. */
    this.fullWidth = false;
    this.dataTrackingId = 'telia-navigation-button';
  }
  render() {
    return (h("div", { class: "telia-navigation-button", "data-testid": this.dataTestid }, h("telia-style-navigation-item", { size: this.size, active: this.active, fullWidth: this.fullWidth }, h("button", { "aria-controls": this.allyControls, "aria-expanded": this.allyExpanded, "aria-label": this.allyLabel }, h("slot", null))), h("telia-vst", { dataTrackingId: this.dataTrackingId })));
  }
};
TeliaNavigationButton.style = teliaNavigationButtonCss;

export { TeliaNavigationButton as telia_navigation_button };
